//https://iqbalfn.github.io/bootstrap-drawer/
import Drawer from './drawer'

export {
    Drawer,
}



// WEBPACK FOOTER //
// ./scripts/drawer/index.js